module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/207-guam-75d969f621da9b806fc53f6b1674327e.svg";